import {
    PUSH_USER_DATA,
    RESET_USER_DATA
} from "./types";

export const pushUserData = (user) => ({
    type: PUSH_USER_DATA,
    payload: user 
});

export const flushUserData = () => ({
    type: PUSH_USER_DATA,
    payload: {}
});

export const resetUserData = () => ({
    type: RESET_USER_DATA,
    payload: {}
});